/**
 * Sticky offer strip announcing the 30:70 subvention plan.
 * Fixed top, full width, above navbar (z-index higher than header).
 * Desktop: 44px single line. Mobile: 56px two lines.
 */
const SubventionStrip = () => {
  return (
    <div
      className="fixed top-0 left-0 right-0 w-full"
      style={{
        zIndex: 60,
        background: '#0A0A0A',
        borderBottom: '1px solid hsl(var(--gold))',
      }}
      role="region"
      aria-label="30:70 Subvention Plan announcement"
    >
      {/* Desktop single-line */}
      <div
        className="hidden md:flex items-center justify-center px-4"
        style={{ height: '44px', fontFamily: "'DM Sans', 'Inter', sans-serif" }}
      >
        <p
          className="text-white text-center"
          style={{ fontSize: '13px', letterSpacing: '0.01em' }}
        >
          <span aria-hidden="true" style={{ color: 'hsl(var(--gold-light))' }}>●</span>{' '}
          <span style={{ color: 'hsl(var(--gold-light))', fontWeight: 600 }}>30:70</span>{' '}
          Subvention Plan Live · Pay just 30% now, 70% on possession · Only 24 residences
        </p>
      </div>

      {/* Mobile two-line */}
      <div
        className="md:hidden flex flex-col items-center justify-center px-3 text-center"
        style={{ height: '56px', fontFamily: "'DM Sans', 'Inter', sans-serif" }}
      >
        <p className="text-white leading-tight" style={{ fontSize: '12px', fontWeight: 600 }}>
          <span style={{ color: 'hsl(var(--gold-light))' }}>30:70</span> Subvention Plan Live
        </p>
        <p className="text-white/85 leading-tight mt-0.5" style={{ fontSize: '12px' }}>
          Pay 30% now, 70% on possession · 24 homes only
        </p>
      </div>
    </div>
  );
};

export const SUBVENTION_STRIP_HEIGHT_DESKTOP = 44;
export const SUBVENTION_STRIP_HEIGHT_MOBILE = 56;

export default SubventionStrip;
